import { gql } from '@apollo/client';

export const USER_GROUPS_QUERY = gql`
  query TicketSelect_UserGroups {
    currentUser {
      _id
      visibleGroupLinks {
        group {
          _id
        }
      }
    }
  }
`;

export const GET_EVENT_REGISTRATIONS = gql`
  query TicketSelect_EventRegistrations($eventId: String!) {
    event(input: { _id: $eventId }) {
      eventV2 {
        _id
        registrations(input: { limit: 1000 }) {
          results {
            _id
            attendeeId
            purchaserId
            ticketId
          }
        }
      }
    }
  }
`;

export const TICKET_SELECT_EVENT_FRAGMENT = gql`
  fragment TicketSelect_EventFragment on EventV2 {
    _id
    isCourseWorkshop
    ... on SimpleEventV2 {
      intutoCourseCollection {
        collectionId
      }
    }
    ... on ConferenceEventV2 {
      intutoCourseCollection {
        collectionId
      }
    }
    visibility {
      type
      groupIds
      userIds
    }
    ticketsCurrentUserCanPurchase {
      _id
      name
      description
      price
      canPurchase {
        ... on Ticket_CanPurchase_MagicLink {
          type
        }
        ... on Ticket_CanPurchase_PermissionConfig {
          type
          permissionConfig {
            allowList
            spec {
              defaultPermission
              permissionGroupIds
              userIds
            }
          }
        }
      }
    }
  }
`;

export const ADD_TO_CART_MODAL_QUERY = gql`
  query AddToCartModal_Query($input: EventInput!) {
    event(input: $input) {
      eventV2 {
        _id
        ticketsCurrentUserCanPurchase {
          _id
          name
          description
          price
          canPurchase {
            ... on Ticket_CanPurchase_MagicLink {
              type
            }
            ... on Ticket_CanPurchase_PermissionConfig {
              type
            }
          }
        }
        ...TicketSelect_EventFragment
      }
    }
    tenant {
      result {
        _id
        accountCreationPermission
      }
    }
  }
  ${TICKET_SELECT_EVENT_FRAGMENT}
`;
